'use client'

import { Toggleable } from '~/components/component-library/Toggleable'

export const SmallBalancesToggle = ({
  isChecked,
  onCheckedChange,
}: {
  isChecked: boolean
  onCheckedChange: (isChecked: boolean) => void
}) => (
  <Toggleable
    layout="compact"
    label="Small balances"
    tooltip="Toggling this on will display balances of <$1.00"
    isChecked={isChecked}
    onCheckedChange={onCheckedChange}
  />
)
